import React from "react";
import { motion } from "framer-motion";
import { Col, Button } from "react-bootstrap";
import ReportCard from "../../components/micheal/ReportCard";
import LeaveBarChart from "../../components/micheal/LeaveReport/LeaveBarChart";
import LeaveReportTable from "../../components/micheal/LeaveReport/LeaveReportTable";
import { FiUsers } from "react-icons/fi";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FaUserSlash } from "react-icons/fa";

function LeaveReport() {

  const stats = [
    {
      title: "Total Employee",
      value: 600,
      progress: 60,
      icon: FiUsers,
      color: "#28a745",
    },
    {
      title: "Active Employee",
      value: 450,
      progress: 40,
      icon: MdOutlineVerifiedUser,
      color: "#ffc107",
    },
    {
      title: "New Employee",
      value: 100,
      progress: 50,
      icon: HiOutlineUserAdd,
      color: "#dc3545",
    },
    {
      title: "Inactive Employee",
      value: 150,
      progress: 45,
      icon: FaUserSlash,
      color: "#0d6efd",
    },
  ];

  const data = [
    { month: "Jan", annual: 20, casual: 30, medical: 10, others: 15 },
    { month: "Feb", annual: 25, casual: 20, medical: 15, others: 10 },
    { month: "Mar", annual: 15, casual: 35, medical: 20, others: 10 },
    { month: "Apr", annual: 30, casual: 25, medical: 15, others: 5 },
    { month: "May", annual: 35, casual: 20, medical: 10, others: 15 },
    { month: "Jun", annual: 25, casual: 30, medical: 20, others: 10 },
    { month: "Jul", annual: 20, casual: 25, medical: 15, others: 20 },
    { month: "Aug", annual: 30, casual: 20, medical: 10, others: 15 },
    { month: "Sep", annual: 15, casual: 30, medical: 20, others: 10 },
    { month: "Oct", annual: 25, casual: 20, medical: 15, others: 15 },
    { month: "Nov", annual: 20, casual: 25, medical: 20, others: 10 },
    { month: "Dec", annual: 30, casual: 20, medical: 10, others: 15 },
  ];

  const tableData = [
    {
      id: 1,
      invoice: "Inv-001",
      name: "Antony Lewis",
      role: "Developer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Paid",
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: 2,
      invoice: "Inv-002",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Sent",
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: 3,
      invoice: "Inv-003",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Partially Paid",
      avatar: "https://i.pravatar.cc/40?img=3",
    },
    {
      id: 1,
      invoice: "Inv-001",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Paid",
      avatar: "https://i.pravatar.cc/40?img=1",
    },
    {
      id: 2,
      invoice: "Inv-002",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Sent",
      avatar: "https://i.pravatar.cc/40?img=2",
    },
    {
      id: 3,
      invoice: "Inv-003",
      name: "Antony Lewis",
      role: "Web Designer",
      company: "Ambrosys Indian PVT LTD",
      created: "14 Jan 2024",
      due: "15 Jan 2026",
      amount: 3000,
      status: "Partially Paid",
      avatar: "https://i.pravatar.cc/40?img=3",
    },
    
  ];

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4 className="mb-0">Leave Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} />
        </Col>

        <Col md={6}>
          <LeaveBarChart data={data} />
        </Col>
      </motion.div>

      {/* TABLE */}
      <LeaveReportTable data={tableData} />

    </div>
  );
}

export default LeaveReport;